import dayjs from 'dayjs'

export function getDate(date) {
  if (!date) {
    return "01 Jan 1999"
  }
  date = dayjs(date).locale('en-IN')
  const newDate = dayjs(date).format('DD MMM YYYY')
  return newDate
}

export function getTime (time) {
  if (!time) {
    return "00:01 AM"
  }
  time = dayjs(time).locale('en-IN')
  const newTime = dayjs(time).format('hh:mm A')
  return newTime
}